import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
})
export class PhonePipe implements PipeTransform {
    transform(phone: string, style?: string) {
        if (!phone) {
            return '';
        }

        let areaCode: string, prefix: string, number: string;

        const phoneclean = phone.replace(/[\(\)\- ]/g, '');

        if (phoneclean.length <= 3) {
            return phone;
        }

        areaCode = phoneclean.slice(0, 3);
        number = phoneclean.slice(3);

        if (number.length > 3) {
            prefix = number.slice(0, 3);
            number = number.slice(3, 7);
        } else {
            prefix = number;
            number = '';
        }

        switch (style) {
            case 'parensdash':
                return `(${areaCode}) ${prefix}${number ? '-' + number : number}`.trim();
            case 'dash':
                return `(${areaCode}-${prefix}${number ? '-' + number : number}`.trim();
            default:
                return (areaCode + prefix + number).trim();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pipes/phone.pipe.ts